module.exports = __webpack_public_path__ + "img/section_4.7c6b8d3c.png";